module.exports = __webpack_public_path__ + "static/media/circle-sm.ae40a821.png";